import {
  Box,
  HStack,
  Button,
  Container,
  Flex,
  IconButton,
  Stack,
  Collapsible,
  Image
} from '@chakra-ui/react';

import { GrClose } from 'react-icons/gr';
import lightLogo from '../assets/logos/white-bg-logo.png';
import darkLogo from '../assets/logos/dark-bg-logo.png';
import { useColorModeValue } from './chakra-ui/color-mode';
import { Link as RouterLink } from 'react-router-dom';
import { ColorModeButton } from './chakra-ui/color-mode';
import React, { useRef, useState, useEffect } from 'react';
import { RxHamburgerMenu } from 'react-icons/rx';
import { NAV_OFFSET } from './core/constants';
import SocialMediaLinks from './social-media';
import { COLORS } from '../theme';

function Header() {
  return (
    <div className="Header">
      <header className="header">
        <Header1 />
      </header>
    </div>
  );
}

// Header Component
function Header1() {
  const [isOpen, setIsOpen] = useState(false);
  const bgColor = useColorModeValue('white', 'black');
  const logo = useColorModeValue(lightLogo, darkLogo);
  const navHoverBg = useColorModeValue('gray.100', 'gray.700');

  const navRef = useRef();
  useEffect(() => {
    function handleClickOutside(event) {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  // Use generic scrollToSection
  const { scrollToSection } = require('./core/scroll-to-section');
  const goToSection = (id) => {
    scrollToSection(id);
  };

  const navItems = [
    { name: 'Home', href: '/#home', htmlElementId: 'home' },
    { name: 'Services', href: '/#services', htmlElementId: 'services' },
    { name: 'Gallery', href: '/#gallery', htmlElementId: 'gallery' },
    { name: 'Videos', href: '/#videos', htmlElementId: 'videos' },
    { name: 'Contact', href: '#contact', htmlElementId: 'contact' }
  ];

  return (
    <Box
      bg={bgColor}
      borderBottom={1}
      borderStyle="solid"
      borderColor={COLORS.brand.primary}
      position="fixed"
      width="auto"
      top="0"
      left="0"
      right="0"
      zIndex="1000"
      shadow="sm"
    >
      <Container maxW="container.xl">
        <Flex h={16} alignItems="center" justifyContent="space-between">
          {/* Mobile Menu Button */}
          <Box display={{ base: 'block', md: 'none' }}>
            <IconButton
              onClick={() => setIsOpen(!isOpen)}
              variant="outline"
              aria-label="Toggle Navigation"
              colorScheme="orange"
              size={{ base: 'md', md: 'md' }}
              minW="44px"
              minH="44px"
            >
              {isOpen ? <GrClose /> : <RxHamburgerMenu />}
            </IconButton>
          </Box>

          {/* Logo */}
          <Box as={RouterLink} to="/#home">
            <Image
              src={logo}
              alt="ViAn Photography Logo"
              boxSize={{ base: '48px', md: '64px' }}
              objectFit="contain"
              cursor={'pointer'}
            />
          </Box>

          {/* Desktop Navigation */}
          <HStack spacing={8} display={{ base: 'none', md: 'flex' }}>
            {navItems.map((item) => (
              <Box
                key={item.name}
                w="100%"
                display="flex"
                justifyContent="center"
                onClick={() => goToSection(item.htmlElementId)}
              >
                {renderNavButton(item, navHoverBg)}
              </Box>
            ))}
          </HStack>

          {/* Right side buttons */}
          <HStack spacing={4}>
            <ColorModeButton />
          </HStack>
        </Flex>

        {/* Mobile Navigation */}
        <Collapsible.Root
          open={isOpen}
          unmountOnExit
          display={{ md: 'none' }}
          onOpenChange={setIsOpen}
          ref={navRef}
        >
          <Collapsible.Content>
            <Box pb={4} display={{ md: 'none' }}>
              <Stack as="nav" spacing={4}>
                {navItems.map((item) => (
                  <Box
                    key={item.name}
                    w="100%"
                    display="flex"
                    justifyContent="center"
                    onClick={() => {
                      goToSection(item.htmlElementId);
                      setIsOpen(false);
                    }}
                  >
                    {renderNavButton(item, navHoverBg)}
                  </Box>
                ))}

                <SocialMediaLinks />
              </Stack>
            </Box>
          </Collapsible.Content>
        </Collapsible.Root>
      </Container>
    </Box>
  );
}

function renderNavButton(item, navHoverBg) {
  return (
    <Button
      key={item.name}
      variant="ghost"
      as={RouterLink}
      to={item.href}
      colorScheme="orange"
      px={{ base: 4, md: 2 }}
      py={{ base: 3, md: 1 }}
      minH={{ base: '44px', md: 'auto' }}
      rounded="md"
      _hover={{
        textDecoration: 'none',
        bg: navHoverBg
      }}
      fontWeight="medium"
    >
      {item.name}
    </Button>
  );
}

export default Header;
